
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BiBulb } from 'react-icons/bi';

export const SelectedTemplateCardList = ({ title, templates, selectedId,classes }) => {
    const selectedTemplates = templates?.filter(item => item?.id === Number(selectedId)) || [];
  
    return (
      <div className={classes.challengeblock}>
        <h3 className={classes.header}>{title}</h3>
        {selectedTemplates.length > 0 ? (
          selectedTemplates.map((item, index) => (
            <IdeaTemplateSelectCard
              key={item.templateName}
              ideaName={item.templateName}
              currentIndex={index}
              onClick={() => {}}
              idealistId={item.id}
              selectedTemplateId={selectedId}
            />
          ))
        ) : (
          `No selected ${title.toLowerCase()} is available.`
        )}
      </div>
    );
  };
  


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  labelName: {
    fontFamily: 'VodafoneRg-bold',
    margin: '0 0 0.5rem 0',
    fontSize: '1.125rem',
    textAlign: 'left',
    color: '#333',
    display: 'block',
  },
  ideaTemplateCardBox: {
    backgroundColor: 'rgba(230, 0, 1, 0.09)',
    padding: '1rem',
    border: 0,
    borderRadius: '4px',
  },
  selectedTemplate: {
    boxShadow: '-3px 4px 1px #ec2828',
  },
  selectbtn: {
    color: '#fff',
    border: '1px solid',
    borderColor: '#e60000',
    display: 'block',
    padding: '0.5rem',
    fontSize: '1rem',
    boxSizing: 'border-box',
    textAlign: 'center',
    transition: 'all 300ms ease',
    fontFamily: 'VodafoneRg-Regular',
    borderRadius: '5px',
    backgroundColor: '#e60000',
  },
}));

const IdeaTemplateSelectCard = ({
  ideaName,
  currentIndex,
  onClick,
  selectedTemplateId,
  idealistId,
}) => {
  const classes = useStyles();
  const isSelected = selectedTemplateId === idealistId;

  return (
    <div
      className={`${classes.ideaTemplateCardBox} ${
        isSelected ? classes.selectedTemplate : ''
      }`}
    >
      <span>
        <BiBulb />
      </span>
      <h3 className={classes.labelName}>{ideaName}</h3>
      <button
        type="button"
        onClick={!isSelected ? onClick : undefined}
        className={classes.selectbtn}
      >
        {isSelected ? 'Selected' : 'Select'}
      </button>
    </div>
  );
};

export default IdeaTemplateSelectCard;
